<template>
  <button :class="{'glass-designer-command-button': true, 'glass-designer-command-button-update': isTypeUpdate, 'active' : active && !disabled, 'selected' : selected && !disabled}" @click.prevent="onClicked" :disabled="disabled">
    <div><i :class="['far', icon]"></i></div>
    <span class="command-button-label" v-if="label">{{label}}</span>
    <span class="command-button-badge" v-if="badge > 0">{{badge}}</span>
    <i class="command-button-success fas fa-check-circle" v-if="showSuccess"></i>
  </button>
</template>

<style lang="scss" scoped>
$command-button-size: 58px;
$command-button-width: 58px;
$command-color-highlight: #68ACE8;
$command-badge-size: 15px;

.glass-designer-command-button {
  display: block;
  position: relative;
  background-color: transparent;
  width: $command-button-width;
  height: $command-button-size;
  border: none;
  border-radius: 0px;
  color: #d3d3d3;
  cursor: pointer;
  clear: both;
  margin: 0px 8px 0px 2px;
  line-height: 16px;
  padding: 0;
}
.glass-designer-command-button.selected {
  color: $command-color-highlight;
  border-radius: 3px;
  border: 1px solid #505050;
  background-color: #373737;

  height: calc(#{$command-button-size} - 8px);
  margin-top: 4px;
  margin-bottom: 4px;
}
.glass-designer-command-button-update {
  color: #4eb93c;
}
.glass-designer-command-button:disabled {
  color: #707070;
  cursor: auto;
}

.glass-designer-command-button.active {
  color: $command-color-highlight;
  border-bottom: 3px solid $command-color-highlight;
}

.glass-designer-command-button:hover:not(:disabled),
.glass-designer-command-button.active {
  color: $command-color-highlight;
}
.glass-designer-command-button:hover:not(:disabled) {
  color: #53a3e9;
}
.glass-designer-command-button i {
  font-size: 22px;
}
.command-button-label {
  font-size: 11px;
}
.glass-designer-command-button .command-button-badge {
  position: absolute;
  top: 2px;
  left: 34px;
  width: $command-badge-size;
  height: $command-badge-size;
  border-radius: 50%;
  background-color: #FF0000;
  color: #FFFFFF;
  font-size: 11px;
  line-height: $command-badge-size;
  vertical-align: middle;
  text-align: center;
  box-shadow: 1px 1px 1px 1px rgba(0,0,0,0.25);
}
.glass-designer-command-button i.command-button-success {
  position: absolute;
  top: 4px;
  left: 34px;
  font-size: 15px !important;
  color: $status-good;
}
</style>

<script>
export default {
  name: 'CommandButton',
  props: {
    icon: String,
    active: Boolean,
    selected: Boolean,
    label: String,
    type: {
      type: String,
      default: 'regular'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    badge: {
      type: Number,
      default: 0
    },
    showSuccess: Boolean
  },
  computed: {
    isTypeUpdate() {
      return this.type == 'update'
    }
  },
  methods: {
    onClicked(evt) {
      this.$emit('click', evt)
    }
  }
}
</script>